import { render, staticRenderFns } from "./articleModal.vue?vue&type=template&id=274bf21c&scoped=true"
import script from "./articleModal.vue?vue&type=script&lang=js"
export * from "./articleModal.vue?vue&type=script&lang=js"
import style0 from "./articleModal.vue?vue&type=style&index=0&id=274bf21c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274bf21c",
  null
  
)

export default component.exports